var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"primary-button",attrs:{"text":_vm.isText,"disabled":_vm.disabled},on:{"click":function () {
      _vm.$emit('click');
    }}},[_vm._v("\n  "+_vm._s(_vm.title)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }